import CreateClientForm from "@/components/Forms/CreateClientForm";

const DashboardAllEndClientsCreate = () => {
  return <CreateClientForm create={true} isEndClient={true}/>;
};

export default DashboardAllEndClientsCreate;
